import { StyledCard } from '@app/components/card/Card';
import { PageMeta } from '@app/components/meta/Meta';
import useAuthActions from '@app/hooks/auth/useAuthActions';
import { fn } from '@app/utils';
import { url } from '@app/utils/constants';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ResetPasswordForm } from './components/ResetPasswordForm';

export type ResetPasswordFormValues = {
    email?: string;
    password: string;
    passwordConfirmation?: string;
};

export const ResetPassword = () => {
    const { setPassword } = useAuthActions();
    const navigate = useNavigate();
    const { secret } = useParams();

    const handleResetPasswordSubmit = async (data: ResetPasswordFormValues) => {
        try {
            await setPassword.mutateAsync(
                {
                    password: data.password,
                    secret: secret || '',
                },
                {
                    onSuccess: () => {
                        navigate(url.home);
                    },
                }
            );
        } catch {
            // Ignore this error as React Query should handle it above
        }
    };

    useEffect(() => {
        if (fn.isLoggedIn()) {
            navigate(url.adminPortal.dashboard);
        }
    }, [navigate]);

    return (
        <>
            <PageMeta title="Forgot Password" />

            <StyledCard showLogo style={{ width: '100%', maxWidth: 680 }}>
                <div className="card-intro">
                    <h1>Update your password</h1>
                </div>
                <br />
                <ResetPasswordForm onSubmit={handleResetPasswordSubmit} />
            </StyledCard>
        </>
    );
};

export default ResetPassword;
